import { useRequirementFieldPath } from './useRequirementFieldPath';

export const useRequirementDataTypeFieldPath = () => {
  const requirement = useRequirementFieldPath();
  return `${requirement}.dataType` as const;
};
